import AdminSettingsUserInformationsForm from "@/components/ui/organisms/Admin/Settings/UserInformations/AdminSettingsUserInformationsForm"
import AdminSettingsUserInformationsReadonly from "@/components/ui/organisms/Admin/Settings/UserInformations/AdminSettingsUserInformationsReadonly";
import { useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_ADMIN_USER_SETTINGS } from "@/graphql/admin/settings/SettingsQueries";
import { useSelectedLinkContext } from "@/contexts";

const AdminSettingsUserInformationsPage = (): JSX.Element => {
  const [isEditMode, setEditMode] = useState<boolean>(false);

  const { selectedLink } = useSelectedLinkContext();
  const { data, refetch } = useQuery(
    GET_ADMIN_USER_SETTINGS,
    {
      variables: {
        getUserProfileInput:  {
          channel: selectedLink?.channelKey,
        }
      },
    },
  );

  return (
    <>
      <h2 className="text-header3 text-white p-2w bg-admin-darkblue-300">Informations sur l'utilisateur</h2>
      {isEditMode ? 
        <AdminSettingsUserInformationsForm initialUserProfile={data?.getUserProfile.profile} setEditMode={setEditMode} refreshData={refetch} /> : 
        <AdminSettingsUserInformationsReadonly userProfile={data?.getUserProfile.profile} setEditMode={setEditMode} />}
    </>
  )
}

export default AdminSettingsUserInformationsPage;